import React, { memo, type RefObject } from 'react';
import { type ScrollViewInstance } from 'react-native';

import { useScrollspyActiveTargetId } from '@garnish/layout';

import { useA11ySelector } from '@sg/a11y-helpers';
import {
  CustomizationIngredientsGrid,
  type CustomizationMachineTypes,
} from '@sg/shared-fe-features-customization';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationIngredientsNav = memo((props: Props) => {
  const { scrollspyActorRef, modificationGroups, navScrollViewRef, onPress } = props;

  const navA11ySelector = useA11ySelector('customization.nav');

  const activeTargetId = useScrollspyActiveTargetId(scrollspyActorRef);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <CustomizationIngredientsGrid.Nav ref={navScrollViewRef} {...navA11ySelector.props}>
      {modificationGroups.map((group) => (
        <CustomizationIngredientsGrid.NavItem
          key={group.id}
          isActive={activeTargetId === group.id}
          navScrollViewRef={navScrollViewRef}
          onPress={onPress}
          targetId={group.id}
          ingredientKindName={group.displayName}
        />
      ))}
    </CustomizationIngredientsGrid.Nav>
  );
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  scrollspyActorRef: Parameters<typeof useScrollspyActiveTargetId>[0];
  modificationGroups: readonly CustomizationMachineTypes.ExtendedModifierGroup[];
  navScrollViewRef: RefObject<ScrollViewInstance | null>;
  onPress: (targetId: string) => void;
};
